import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useStyles = createUseStyles((theme: ITheme) => ({
  sidebarCategory: {
    '--icon-color': theme.colors.texts.tint1,
    '--text-color': theme.colors.texts.tint1,
    '--transition-timing': '1s',
    '--transition-easing-type': 'ease',
    width: '100%',
    margin: [theme.spacings.s8, theme.spacings.s0],
    borderRadius: theme.radiuses.r8,
    transition: 'background-color var(--transition-timing) var(--transition-easing-type)',
    '@media(hover: hover)': {
      '&[disabled]': {
        cursor: 'not-allowed',
      },
      '&:not([disabled])': {
        cursor: 'pointer',
      },
      '&:not($active):not([disabled])': {
        '&:hover': {
          '--icon-color': theme.colors.texts.base,
          '--text-color': theme.colors.texts.base,
          '& $categoryText': {
            color: 'var(--icon-color)',
          },
        },
      },
    },
    '&[disabled]': {
      '--icon-color': theme.colors.texts.tint2,
      '--text-color': theme.colors.texts.tint2,
    },
    '& path': {
      fill: 'var(--icon-color)',
      transition: 'fill var(--transition-timing) var(--transition-easing-type)',
    },
    '& $categoryText': {
      color: 'var(--text-color)',
      transition: 'color var(--transition-timing) var(--transition-easing-type)',
      '&:not($categoryTextTruncatedMultiLine)': {
        whiteSpace: 'nowrap',
      },
    },
  },
  sidebarTextIconWrap: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  sidebarIcon: {
    width: theme.variables.iconSize,
    height: theme.variables.iconSize,
    margin: `${theme.spacings.s0} auto ${theme.spacings.s4} auto`,
  },
  categoryText: {
    color: 'var(--text-color)',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  categoryTextTruncatedMultiLine: {
    '--max-visible-row-count': '2',
    display: '-webkit-box',
    wordBreak: 'break-word',
    '-webkit-line-clamp': 'var(--max-visible-row-count)',
    '-webkit-box-orient': 'vertical',
  },
  active: {
    '--icon-color': theme.colors.accents.primary.base.default,
    '--text-color': theme.colors.accents.primary.base.default,
  },
}));

export default useStyles;
